import { useMutation } from '@tanstack/react-query';

import { openChangeTariffPopup } from '@entities/tariff/lib/openChangeTariffPopup';

export const useGetOpenChangeTariffPopup = () =>
    useMutation({
        mutationFn: openChangeTariffPopup,
    });
